/**
 * The sizing every dense form field shares, in CSS px, so fields in one
 * column line up edge, swatch and text.
 */
export const FIELD_SIZING = {
    /** Height of a single-line field. */
    height: 32,
    /** Inset of the content from the field's left and right edges. */
    paddingX: 8,
    /** Space between a field's adornment, such as a swatch, and its text. */
    gap: 8,
    /** Side of a structure's colour swatch. */
    swatch: 8,
} as const;

/**
 * The trailing chevron of a select or autocomplete: a 12 px icon whose
 * stroke glyph is 6 px wide and sits 3 px in from the icon's edges.
 */
export const FIELD_CHEVRON = {
    size: 12,
    glyphWidth: 6,
    glyphInset: 3,
} as const;
